import styled, { css } from 'styled-components';
import Typography from '../../typography';
import { pxToRem } from '../../../design-tokens/style-utilities';
/**
 * Gallery title container
 */
export const galleryTitleContainerStyles = ({ theme }) => css `
	grid-row: 3;
	grid-column: slide;
	display: none;
	padding-top: ${pxToRem(theme.spacing['200'])};
	margin: 0;
`;
export const GalleryTitleContainer = styled(Typography).attrs({
    variant: 'content-subtitle',
}) `
	${galleryTitleContainerStyles}
`;
